import { render, staticRenderFns } from "./StepComponent.vue?vue&type=template&id=6d818acc&scoped=true"
import script from "./StepComponent.vue?vue&type=script&lang=js"
export * from "./StepComponent.vue?vue&type=script&lang=js"
import style0 from "./StepComponent.vue?vue&type=style&index=0&id=6d818acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d818acc",
  null
  
)

export default component.exports